import React from 'react'
import styles from './index.module.css'
import { cn, type UtilityClassNames } from '@s4l/utility-css'

interface BarChartProps {
  className?: UtilityClassNames
  barColor?: string[]
  data: number[]
  scale?: 'linear' | 'log' | 'sqrt'
}

const BarChart = ({ data, barColor, className, scale = 'linear' }: BarChartProps) => {
  const minY = 0
  const maxY = Math.max(...data)

  const normalize = (value: number): number => {
    if (maxY === minY) return 50

    switch (scale) {
      case 'log': {
        const logMin = Math.log(minY + 1)
        const logMax = Math.log(maxY + 1)
        const logValue = Math.log(value + 1)
        return ((logValue - logMin) / (logMax - logMin)) * 100
      }

      case 'sqrt': {
        const sqrtMin = Math.sqrt(minY)
        const sqrtMax = Math.sqrt(maxY)
        const sqrtValue = Math.sqrt(value)
        return ((sqrtValue - sqrtMin) / (sqrtMax - sqrtMin)) * 100
      }

      case 'linear':
      default:
        return ((value - minY) / (maxY - minY)) * 100
    }
  }

  return (
    <div className={cn(styles.chart, className)}>
      {data.map((bar, index) => {
        const normalizedHeight = normalize(bar)
        return (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={styles.bar}
            style={{ height: `${normalizedHeight}%`, backgroundColor: barColor?.[index] }}
            title={`${bar}`}
          />
        )
      })}
    </div>
  )
}

BarChart.displayName = 'Chart.BarChart'
export default BarChart
